import React, { useEffect } from "react"
import PropTypes from "prop-types"
import AOS from "aos"
import { HeaderSansNav } from "@components/Header"
import { GeneralDarkForm } from "@components/Form"
import { FooterDark } from "@components/Footer"

export const YearInReviewLayout = ({ children }) => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "expo-ease-out",
    })
  }, [])

  return (
    <div className="overflow-hidden bg-gray">
      {/* <Cursor /> */}
      <HeaderSansNav />
      <main>{children}</main>
      <section className="container mt-11">
        <div className="mx-auto xl:w-10/12">
          <GeneralDarkForm />
        </div>
      </section>
      <section className="mt-20">
        <div className="container">
          <div className="flex">
            <div className="flex items-center justify-center w-1/2 py-5 sm:py-9 lg:py-12 bg-blue-light">
              <a
                href="https://www.instagram.com/jk.design/"
                target="_blank"
                rel="noreferrer"
                className="block w-12 transition-all duration-300 fill-current lg:w-20 text-gray-darkest sm:hover:text-teal"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="100%">
                  <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
                </svg>
              </a>
            </div>
            <div className="flex items-center justify-center w-1/2 py-5 sm:py-9 lg:py-12 bg-teal-light">
              <a
                href="https://linkedin.com/company/jk-design/mycompany/"
                target="_blank"
                rel="noreferrer"
                className="block w-12 transition-all duration-300 fill-current text-gray-darkest sm:hover:text-teal lg:w-15"
              >
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="100%">
                  <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>
      <FooterDark />
    </div>
  )
}

YearInReviewLayout.propTypes = {
  children: PropTypes.node,
}
